import React, { useEffect, useRef, useState } from 'react'
import { Poppins, Quicksand } from 'next/font/google'
import Image from 'next/image'

const popins = Poppins({ weight: ['400', '500', '600', '700'], subsets: ['latin'], display: 'swap', preload: true })
const quickSand = Quicksand({ weight: ['400', '500'], subsets: ['latin'], display: 'swap', preload: true })

export default function CourseOverview({ SectionRef, title, location1, overview, img }) {
  const [expanded, setExpanded] = useState(false);
  const contentRef = useRef(null);
  const [height, setHeight] = useState("400px");
  const [showReadMore, setShowReadMore] = useState(false);

  useEffect(() => {
    if (contentRef.current) {
      if (contentRef.current.scrollHeight > 400) {
        setShowReadMore(true); // Show "Read More" button only if content exceeds 400px
      } else {
        setShowReadMore(false);
      }
    }
  }, [overview]); // Check when overview changes

  useEffect(() => {
    setHeight(expanded ? `${contentRef.current.scrollHeight}px` : "400px");
  }, [expanded]);

  return (
    <>
      <section className={`container`} ref={SectionRef}>
        <div className='whole-pdtb'>
          <h2 className={`fs-30 tfs-28 mfs-21 fwb600 ${popins.className}`}>
            {title} - <span className={`ylw-clr fs-30 tfs-28 mfs-21 fwb600 ${popins.className}`}> Course Overview</span>
          </h2>

          <div className={`df fjsb fw mfac mfjc tmt20 mmt16`}>
            <div className={`w55p mw100p`}>
              <div
                ref={contentRef}
                // className={`fs-16 mfs-15 fwb400  ${quickSand.className}`}
                style={{
                  maxHeight: height,
                  overflow: "hidden",
                  transition: "max-height 0.5s ease-in-out",
                }}
              >
                {overview.map((items, index) => (
                  <div
                    key={index}
                    className={`fs-16 mfs-15 fwb400 overview-style ${quickSand.className}`}
                    dangerouslySetInnerHTML={{
                      __html: items.replace(/in\${(.*?)}/g, function (match, p1) {
                        return location1 || " ";
                      }),
                      
                    }}
                  ></div>
                ))}
              </div>

              {/* Conditionally render Read More / Read Less button */}
              {showReadMore && (
                <button
                  onClick={() => setExpanded(!expanded)}
                  className="btn-readmore"
                  style={{
                    marginTop: "10px",
                    cursor: "pointer",
                    background: "none",
                    border: "none",
                    color: "#f4b400",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  {expanded ? "Read Less" : "Read More"}
                </button>
              )}
            </div>

            <div className='img-sticky mt14'>
              <Image className='br20 mdn mt8' src={`/course/${img}-training.webp`} width={505} height={336} alt={`${title} `} loading='eager' quality={100} />
              <Image className='br20 dn mdb mmt24' src={`/course/${img}-training.webp`} width={290} height={193} alt={`${title}`} loading='eager' quality={100} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
